import { api } from '..'

export const assignDeviceToGroup =
  (deviceGroupId: string, deviceId: string) => () =>
    api.post(`/v1/device-group/${deviceGroupId}/devices/${deviceId}`)

export const removeDeviceFromGroup =
  (deviceGroupId: string, deviceId: string) => () =>
    api.delete(`/v1/device-group/${deviceGroupId}/devices/${deviceId}`)
